import { frontendURL } from '../../../helper/URLHelper';
import RentalBookings from './Index.vue';
import store from '../../../store/index';
import { subscriptionGuard } from '../../../helper/subscriptionHelper';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/rental_bookings'),
      name: 'rental_bookings',
      component: RentalBookings,
      meta: {
        permissions: ['administrator', 'restricted'],
      },
      // Router guard to check subscription using cached data
      beforeEnter: async (to, from, next) => {
        await subscriptionGuard(to, from, next, store);
      },
    }
  ],
};
